import {
    Box,
    FormField,
    TextInput,
    CheckBoxGroup,
    ResponsiveContext,
} from "grommet";
import { useRouter } from "next/router";
import React, { useContext, useEffect, useState } from "react";
import Drawer from "../../components/Drawer";
import Form from "../../components/Form";
import StatusMessage from "../../components/StatusMessage";
import { validateEmail } from "../../lib/validation";
import { handleErrors } from "../../utils/errors";
import { getPermissionOptions } from "../../utils/permissions";
import { useEnabledFeatures } from "../../utils/useEnabledFeatures";
import { NotificationsContext } from "../NotificationsProvider";

const InviteTeammateDrawer = ({
    onClose,
    onSuccess
}) => {
    const router = useRouter();
    const { hasDepositLinks } = useEnabledFeatures();
    const permissionOptions = getPermissionOptions({ hasDepositLinks });
    const [formValues, setFormValues] = useState({
        first_name: "",
        last_name: "",
        email: "",
        permissions: permissionOptions.map(item => item.value), // by default all permission should be changed
    });
    const [updateError, setUpdateError] = useState();
    const size = useContext(ResponsiveContext);
    const notificationCtx = useContext(NotificationsContext);

    useEffect(() => {
        router.prefetch("/settings");
    }, []);

    const addTeammate = ({ value, callback }) => {
        fetch("/api/settings/team", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(value),
        })
            .then(handleErrors)
            .then((data) => {
                if (callback) callback(data);
                onSuccess && onSuccess(data);
                return data;
            })
            .then(() => {
                notificationCtx.showNotification({ message: "Invite sent!" });
            })
            .catch(setUpdateError);
    };

    return (
        <Drawer title="Invite teammate" onClose={onClose}>
            <Box width={size === "small" ? "auto" : "medium"}>
                {updateError && (
                    <StatusMessage apiError={updateError} />
                )}
                <Form
                    onReset={onClose}
                    onSubmit={(event) => {
                        if (event.value?.permissions.length === 0) {
                            setUpdateError({
                                message: "Missing permissions",
                            });
                        } else {
                            addTeammate({
                                value: event.value,
                                callback: onClose,
                            });
                        }
                    }}
                    onChange={(nextValue) => {
                        setUpdateError(undefined);
                        setFormValues(nextValue);
                    }}
                    value={formValues}
                    editOnly
                    sectionProps={{
                        margin: "none",
                        border: false,
                        pad: "none",
                        headerProps: {
                            border: false,
                        },
                    }}
                    submitText="Send invite"
                >
                    <FormField
                        label="First name"
                        placeholder="First name"
                        name="first_name"
                        component={TextInput}
                        required
                    />
                    <FormField
                        label="Last name"
                        name="last_name"
                        placeholder="Last name"
                        component={TextInput}
                        required
                    />
                    <FormField
                        label="Work email"
                        placeholder="Work email"
                        name="email"
                        validate={validateEmail}
                        component={TextInput}
                        required
                    />
                    <FormField
                        label="Permissions"
                        name="permissions"
                        htmlFor="permissions"
                        required
                    >
                        <CheckBoxGroup
                            id="permissions"
                            name="permissions"
                            options={permissionOptions}
                            labelKey="label"
                            valueKey="value"
                        />
                    </FormField>
                </Form>
            </Box>
        </Drawer>
    );
};

export default InviteTeammateDrawer;
